export default __webpack_public_path__ + "static/media/slovakia.1c576836.svg";